export default {"src":"/_next/static/media/fintech-banking-firm.857aa95c.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};